import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function applyCheckoutProfile(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, langId, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of applyCheckoutProfile()');
    invariant(brandId, 'brandId is a required param of applyCheckoutProfile()');
    invariant(country, 'country is a required param of applyCheckoutProfile()');
    invariant(uberToken, 'uberToken is a required param of applyCheckoutProfile()');
    invariant(clientId, 'clientId is a required param of applyCheckoutProfile()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/applyCheckoutProfile${query ? `?${query}` : ''}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT' }), uberToken, clientId, clientSecret),
        'applyCheckoutProfile',
    );
}
